/**
 * Whether the agent-status control must be withheld from a user: on the new engine
 * their status is pinned Available, and api-core refuses every write that is not
 * Available.
 *
 * api-core serves the user-shaped half as `agent_status_pinned_on_new_engine`
 * (extensions, and active users answering on a phone number) and leaves the engine
 * out, so an engine toggle arriving on the company broadcast reaches the control
 * without a reload. Read the company live rather than one captured at mount.
 *
 * @param {Object} user
 * @param {Object} company
 * @returns {Boolean}
 */
export function isAgentStatusPinned (user, company) {
  return Boolean(company?.use_new_engine && user?.agent_status_pinned_on_new_engine)
}
